<template>
  <el-upload
      class="file-uploader"
      :action="action"
      :multiple="multiple"
      :limit="limit"
      :data="data"
      :accept="accept"
      :show-file-list="showFileList"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-change="handleChange"
      :before-upload="beforeUpload"
      :on-remove="handleRemove"
      :file-list="internalFileList"
      :auto-upload="autoUpload"
      list-type="text"
  >
    <el-button size="small" type="primary">{{ buttonText }}</el-button>

    <!-- 自定义文件项 -->
    <template #file="{ file }">
      <div style="display: flex; align-items: center;">
        <el-link
            :href="file.url"
            target="_blank"
            style="margin-right: 10px;"
            v-if="file.url"
        >
          {{ file.name }}
        </el-link>
        <span v-else style="margin-right: 10px;">{{ file.name }}</span>
        <el-button
            size="mini"
            type="text"
            @click="removeFile(file)"
        >
          删除
        </el-button>
      </div>
    </template>

    <div slot="tip" class="el-upload__tip" v-if="tip">{{ tip }}</div>
  </el-upload>
</template>

<script>
import {API_BASE_URL} from "@/config";

export default {
  name: 'FileUploader',

  props: {
    action: {type: String, default: API_BASE_URL + 'Airdrop/uploadPic'},

    multiple: {type: Boolean, default: false},
    limit: {type: Number, default: 0},
    data: {
      type: Object, default: () => {
        let shangchuanData = {}
        let xinxi = sessionStorage.getItem('admintoken') ? sessionStorage.getItem('admintoken') : ''
        shangchuanData.token = xinxi ? xinxi : ''
        return shangchuanData
      }
    },
    accept: {type: String, default: ''},
    showFileList: {type: Boolean, default: true},
    fileList: {type: Array, default: () => []},
    autoUpload: {type: Boolean, default: true},
    buttonText: {type: String, default: '点击上传'},
    tip: {type: String, default: ''},
    beforeUpload: {type: Function, default: () => true},
  },
  data() {
    return {
      internalFileList: []
    };
  },
  watch: {
    fileList: {
      immediate: true,
      handler(newVal) {
        this.internalFileList = [...newVal];
      }
    }
  },
  methods: {
    handleSuccess(response, file, fileList) {
      if (response.status != 1) {
        this.$message.error('文件上传失败')
      }else{
        file.url = response?.img || ''; // 确保url存在
        this.internalFileList = [...fileList];
        this.$emit('success', file);
      }

    },
    handleError(err, file, fileList) {
      this.$emit('error', err, file, fileList);
    },
    handleChange(file, fileList) {
      this.internalFileList = [...fileList];
      this.$emit('change', file, fileList);
    },
    handleRemove(file, fileList) {
      this.internalFileList = [...fileList];
      this.$emit('remove', file, fileList);
    },
    removeFile(file) {
      const index = this.internalFileList.findIndex(f => f.uid === file.uid);
      if (index !== -1) {
        this.internalFileList.splice(index, 1);
        this.$emit('remove', file, this.internalFileList);
      }
    }
  }
};
</script>

<style scoped>
.file-uploader ::v-deep .el-upload-list--text {
  margin: 0;
}

.file-uploader ::v-deep .el-upload-list__item {
  min-height: 32px;
  display: flex;
  align-items: center;
  transition: none;      /* 禁用默认动画 */
  opacity: 1;
}

.file-uploader ::v-deep .el-upload-list__item.is-uploading .el-progress {
  transition: none;
  opacity: 1;
}

.file-uploader ::v-deep .el-upload-list__item:hover {
  background-color: transparent; /* 避免 hover 闪 */
}
.form-upload-wrapper {
  display: inline-flex;     /* 或 block，视布局而定 */
  width: 100%;              /* 保持稳定宽度 */
  min-height: 48px;
}
.form-upload-wrapper .file-uploader {
  flex: 1;
}
.form-upload-wrapper {
  contain: layout paint;  /* 只影响自身，不再受外部输入重排影响 */
  will-change: transform; /* 提前让浏览器单独合成，缓解闪烁 */
}
.form-upload-wrapper ::v-deep .el-upload-list__item,
.form-upload-wrapper ::v-deep .el-upload-list__item .el-progress {
  transition: none;
  opacity: 1;
}
</style>
